import { useState } from 'react';
import { Save } from "lucide-react";

const MultipleStudentsAdd = ({ onClose }) => {
    const [studentsText, setStudentsText] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/settings/multiStudents`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ studentsText })
            });
            const data = await res.json();
            console.log('Odpowiedź backendu:', data);

            if (data.success) {
                alert('Kursanci dodani pomyślnie!');
                onClose();
            } else {
                alert('Coś poszło nie tak...');
            }
        } catch (err) {
            console.error(err);
            alert('Błąd serwera');
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h3 className="modal-title">Dodaj Wielu Kursantów</h3>
                <form>
                    <div className="form-group">
                        <h4 style={{marginBottom: '8px'}}>Dodaj kursantów</h4>
                        <p style={{marginBottom: '12px'}}>Kursanci powini być wypisani w podanym formacie:</p>
                        <code style={{marginBottom: '12px', display: 'block', backgroundColor: '#f0f0f0', padding: '8px', borderRadius: '4px'}}>
                            imie1,nazwisko1,email1 <br/>
                            imie2,nazwisko2,email2 <br/>
                            imie3,nazwisko3,email3 <br/>
                            ... <br/>
                        </code>
                        <textarea
                            style={{width: '98%', height: '300px', padding: '8px', borderRadius: '4px', borderColor: '#ccc'}}
                            placeholder='Wpisz kursantów w podanym formacie...'
                            value={studentsText}
                            onChange={(e) => setStudentsText(e.target.value)}
                        />
                    </div>
                    <div className="modal-actions">
                        <button type='button' onClick={onClose} className="button-secondary">Anuluj</button>
                        <button type='submit' className="button-primary" onClick={handleSubmit}>
                            <Save size={16} />
                            <span>{loading ? 'Dodawanie...' : 'Zapisz'}</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default MultipleStudentsAdd;